import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.netsuite.InvoiceShippingDetailsSection', {
    title: 'Shipping Details',
    shippingDatePlaceholder: 'Select date',
    shippingDateLabel: 'Shipping date',
    shippingMethodLabel: 'Shipping method',
    shippingMethodPlaceholder: 'Select method',
    shippingAddressLabel: 'Shipping address',
    shippingAddressPlaceholder: 'Select address',
    fieldRequired: 'This field is required',
});
